module.exports = __webpack_public_path__ + "static/media/SourceSansPro-SemiBold.83476a89.ttf";